import { enviroments } from '@infrastructure/enviroments';
import { Customer } from '@models';
import { base } from '@service/base';
import { CountResponse, TakeSkipFilter } from '@typings';

const BANNER_MS_BASE_URL = enviroments.BASE_URL;

export async function getUsersBySegments({
  skip,
  take,
  filter,
}: TakeSkipFilter): Promise<CountResponse<Customer.CustomerResponse>> {
  let where = {};
  if (filter) {
    Object.keys(filter).forEach(key => {
      if (filter[key]) {
        where = {
          ...where,
          [key]: filter[key],
        };
      }
    });
  }

  const { data } = await base({
    baseURL: BANNER_MS_BASE_URL,
    url: `/segments/customers`,
    method: 'GET',
    params: {
      where: JSON.stringify({
        ...where,
      }),
      returnCount: true,
      skip: skip ?? 0,
      take: take ?? 10,
    },
  });

  if (!data) {
    throw Error(data.message);
  }

  return data;
}
